import moment from 'moment'

export default (from, to) => {
  const result = []
  for (let m = moment(from); m.isBefore(to); m.add(1, 'days')) {
    result.push(m.toDate())
  }
  return result
}



// WEBPACK FOOTER //
// ./client/utils/eachDay.js